import React, { Component } from 'react';
import $ from "jquery"
import './Overview.css'


class Overview extends Component {
  render() {

    function checkViewPort() {
      var check;
      var top_of_element = $(".underline-level1").offset().top;
      var bottom_of_element = $(".underline-level1").offset().top + $(".underline-level1").outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)) {
        check = true;
      } else {
        check = false;
      }
      return check;
    }

    $(function () {
      var element = $(".underline-level1");
      $(window).on('scroll', function () {
        if (checkViewPort()) {
          element.addClass("animateMe");
        }
      });
    });

    return (
      <div>
        <div className='mx-3 text-center'>
          <div className='underline-level1'></div>
          <h1 className="text-mint lato-light">Overview</h1>
          <p className='py-3'>Perky pandas club is a collection of 5555 random generative NFTs on ethereum blockchain. Made out of high resolution, hand drawn illustration of more than 150 attributes. Build a large community around them. Own a Panda and enjoy exclusive owner only benefits. Pandas are alway cheerful and ready to play with. Be like Panda.</p>
        </div>
      </div>
    );
  }
}

export default Overview;
